import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TeamLogo } from "../shared/TeamLogo";

export function ReportHeader({ teamId, teamName, reportType, year, children }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-6 bg-white rounded-xl border border-gray-100 shadow-sm px-5 py-4">
      <div className="flex items-center gap-3">
        {teamId && (
          <TeamLogo
            teamId={teamId}
            teamName={teamName}
            size="h-12 w-12"
          />
        )}
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{teamName}</h1>
          <p className="text-sm text-gray-500">{reportType} · {year}</p>
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <button
          onClick={() => navigate("/scouting")}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
        >
          <ArrowLeft size={14} />
          Back to Scouting
        </button>
        {children}
      </div>
    </div>
  );
}
